export const CSV_SCHEMA_COLUMNS = [
  { name: 'Created Date Time', key: 'created_date_time', data_type: 'date' },
  { name: 'Start Date Time', key: 'start_date_time', data_type: 'date' },
  { name: 'Start Date', key: 'start_date', data_type: 'date' },
  { name: 'Start Time', key: 'start_time', data_type: 'time' },
  { name: 'Provider', key: 'provider', data_type: 'string' },
  { name: 'Patient', key: 'patient', data_type: 'string' },
  {
    name: 'Patient First Name',
    key: 'patient_first_name',
    data_type: 'string',
  },
  { name: 'Patient Last Name', key: 'patient_last_name', data_type: 'string' },
  { name: 'Patient EHR/MRN ID', key: 'patient_ehr_id', data_type: 'string' },
  { name: 'Phone Number', key: 'phone_number', data_type: 'string' },
  { name: 'Email', key: 'email', data_type: 'string' },
  { name: 'Appointment Type', key: 'appointment_type', data_type: 'string' },
  {
    name: 'Appointment Status',
    key: 'appointment_status',
    data_type: 'string',
  },
  { name: 'Birth Date', key: 'birth_date', data_type: 'date' },
  { name: 'Sex', key: 'sex', data_type: 'string' },
  { name: 'Primary Address 1', key: 'primary_address_1', data_type: 'string' },
  { name: 'Primary Address 2', key: 'primary_address_2', data_type: 'string' },
  { name: 'City', key: 'city', data_type: 'string' },
  { name: 'State', key: 'state', data_type: 'string' },
  { name: 'Zip', key: 'zip', data_type: 'string' },
  { name: 'Appointment Notes', key: 'appt_notes', data_type: 'string' },
  { name: 'Misc. Column', key: 'misc_column', data_type: 'string' },
] as const;

export type CSVSchemaColumnKey = (typeof CSV_SCHEMA_COLUMNS)[number]['key'];

export type CSVParsedRow = {
  [K in CSVSchemaColumnKey]?: string | number | null;
};

export type CSVColumnMapping = {
  [columnName: string]: string;
};

export type CSVDateTimeFormats = {
  date_format: string;
  time_format: string;
  birth_date_format?: string;
};

export type BulkUploadSettings = {
  column_mapping?: CSVColumnMapping;
  date_format?: string;
  time_format?: string;
  birth_date_format?: string;
  timezone?: string;
  practitioner_mapping?: Record<string, string>;
};

export const REQUIRED_COLUMNS: CSVSchemaColumnKey[] = [
  'phone_number',
  'email',
  'appointment_type',
  'appointment_status',
  'birth_date',
];

export const COLUMNS_TO_HIDE_IF_NOT_PRESENT: CSVSchemaColumnKey[] = [
  'patient',
  'patient_first_name',
  'patient_last_name',
  'start_date_time',
  'start_date',
  'start_time',
  'appt_notes',
  'misc_column',
];

export const DATE_TIME_COLUMNS: CSVSchemaColumnKey[] = [
  'start_date_time',
  'created_date_time',
];

export const TIME_COLUMNS: CSVSchemaColumnKey[] = ['start_time'];

export const DATE_COLUMNS: CSVSchemaColumnKey[] = ['start_date', 'birth_date'];
